const $ = require('jquery');
import Cleave from 'cleave.js';

$('.js-number-input').each((i, el) => {
    const className = `cleave-input-${i}`;

    $(el).addClass(className);

    const cleave = new Cleave(`.${className}`, {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
    });
});
